import { UserRole } from '@gooduncles/gu-app-schema';
import { FC, ReactNode } from 'react';

import { channelRoutes } from './channelRoutes';
import { commerceNoticeRoutes } from './commerceNoticeRoutes';
import { dashboardRoutes } from './dashboardRoutes';
import { deliveryRoutes } from './deliveryRoutes';
import { inventoryRoutes } from './inventoryRoutes';
import { issueRoutes } from './issueRoutes';
import { logRoutes } from './logRoutes';
import { messageRoutes } from './messageRoutes';
import { notificationRoutes } from './notificationRoutes';
import { orderRoutes } from './orderRoutes';
import { productRoutes } from './productRoutes';
import { purchaseOrderRoutes } from './purchaseOrderRoutes';
import { settingsRoutes } from './settingsRoutes';
import { settlementRoutes } from './settlementRoutes';
import { statsRoutes } from './statsRoutes';
import { storeCategoryRoutes } from './storeCategoryRoutes';
import { storeRoutes } from './storeRoutes';
import { userRoutes } from './userRoutes';

// 사이트맵 항목의 타입 정의
export interface SiteMapItem {
  title: string;
  page: FC<any>;
  icon?: ReactNode;
  key: string;
  role?: UserRole[];
  children?: SiteMapChild[];
}

// 사이트맵 하위 메뉴 항목의 타입 정의
export interface SiteMapChild {
  label: string;
  icon: ReactNode | null;
  key: string;
  role?: UserRole[];
  /** 특정 이메일만 접근 허용 (미지정 시 전체 허용) */
  emails?: string[];
}

// 전체 사이트맵 타입 정의
export type SiteMap = Record<string, SiteMapItem>;

// 각 섹션별 사이트맵을 가져오는 함수
export const getSiteMap = (): SiteMap => {
  // 각 모듈에서 정의된 사이트맵을 가져와 병합
  return {
    ...inventoryRoutes,
    ...purchaseOrderRoutes,
    ...dashboardRoutes,
    ...orderRoutes,
    ...issueRoutes,
    ...settlementRoutes,
    ...productRoutes,
    ...storeCategoryRoutes,
    ...userRoutes,
    ...storeRoutes,
    ...deliveryRoutes,
    ...notificationRoutes,
    ...channelRoutes,
    ...statsRoutes,
    ...logRoutes,
    ...messageRoutes,
    ...commerceNoticeRoutes,
    ...settingsRoutes,
  };
};
